module.exports = __webpack_public_path__ + "static/media/project14.9f134b05.jpg";